// extracted by mini-css-extract-plugin
export var programStep = "ProgramStep-module--programStep--1zg49";
export var programStep__imageWrap = "ProgramStep-module--programStep__imageWrap--2UZrd";
export var programStep__image = "ProgramStep-module--programStep__image--5ZNw3";
export var programStep__text = "ProgramStep-module--programStep__text--1Crsk";